import * as Yup from 'yup'

const dateReservationValidator = Yup.object ({
  description: Yup
    .string ()
    .required ('Insira uma descrição'),

  startDate: Yup
    .string ()
    .required ('Selecione uma data de início'),

  endDate: Yup
    .string ()
    .required ('Selecione uma data final'),
  
  period: Yup
    .object ()
    .nullable ()
    .required ('Selecione um período'),
})

export default dateReservationValidator
